'use strict';

ixModuleRouting("impactx.calendar", {
    "/calendarlist": {
        template: "<ixa-calendar-definition-list></ixa-calendar-definition-list>",
        process: "EditCalendarDefinition",
        workspace: "admin",
    },
    "/closedcalendar/:lotId/:tenderId": {
        template: "<ixa-closed-calendar-dialog></ixa-closed-calendar-dialog>",
        process: "EditClosedCalendar",
        workspace: "content",
    },
});
